/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tab_UnreadInputs */

const en_notifications_tab_unread = /** @type {(inputs: Notifications_Tab_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread`)
};

const pt_br2_notifications_tab_unread = /** @type {(inputs: Notifications_Tab_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não lidas`)
};

/**
* | output |
* | --- |
* | "Unread" |
*
* @param {Notifications_Tab_UnreadInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_tab_unread = /** @type {((inputs?: Notifications_Tab_UnreadInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tab_UnreadInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_tab_unread(inputs)
	return pt_br2_notifications_tab_unread(inputs)
});